export default "__VITE_ASSET__ClJAESMo__"